import { Icon } from '@aibees/shared/components';
import { Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

export type DialogPresetId = 'RESET_USER' | 'RESET_TEAM' | 'BAN_USER';

interface DialogPreset {
  title: ReactNode;
  content: ReactNode;
  okTitle: ReactNode;
  okProps?: {
    color?: 'primary' | 'error';
    variant?: 'outlined' | 'contained';
  };
  action?: () => Promise<void> | void;
}

export const dialogPresets: Record<DialogPresetId, DialogPreset> = {
  RESET_USER: {
    title: (
      <Stack direction="row" alignItems="center" gap={0.5}>
        <Icon name="password" size={24} color="primary.400" />
        <Typography variant="body2" color="grey.800" fontWeight={600}>
          Reset Password
        </Typography>
      </Stack>
    ),
    content: (
      <Stack gap={1}>
        <Typography variant="body4" color="grey.900" fontWeight={500}>
          Are you sure you want to reset this user's password?
        </Typography>
        <Typography variant="body4" color="grey.900" fontWeight={500}>
          They will receive instructions to set a new password and will no
          longer be able to log in with their current one.
        </Typography>
      </Stack>
    ),
    okTitle: 'Reset Password',
    okProps: { color: 'primary', variant: 'contained' },
    action: () => console.log('[RESET_USER] Action triggered'),
  },
  RESET_TEAM: {
    title: (
      <Stack direction="row" alignItems="center" gap={0.5}>
        <Icon name="password" size={24} color="primary.400" />
        <Typography variant="body2" color="grey.800" fontWeight={600}>
          Team-wide Password Reset
        </Typography>
      </Stack>
    ),
    content: (
      <Stack gap={1}>
        <Typography variant="body4" color="grey.900" fontWeight={500}>
          Resetting the password will affect all users in this account,
          including the Owner and all associated Members.
        </Typography>
        <Typography variant="body4" color="grey.900" fontWeight={500}>
          Make sure you understand the impact before continuing.
        </Typography>
      </Stack>
    ),
    okTitle: 'Reset Password',
    okProps: { color: 'primary', variant: 'contained' },
    action: () => console.log('[RESET_TEAM] Action triggered'),
  },
  BAN_USER: {
    title: (
      <Stack direction="row" alignItems="center" gap={0.5}>
        <Icon name="close-circle-outline" size={20} color="primary.400" />
        <Typography variant="body2" color="grey.800" fontWeight={600}>
          Confirm Account Ban
        </Typography>
      </Stack>
    ),
    content: (
      <Stack gap={1}>
        <Typography variant="body4" color="grey.900" fontWeight={500}>
          You are about to ban the <b>Owner</b> of an account.
        </Typography>
        <Typography variant="body4" color="grey.900" fontWeight={500}>
          This action will also ban all linked Members under the same account.
          Please confirm to proceed.
        </Typography>
      </Stack>
    ),
    okTitle: 'Ban Owner and Team',
    okProps: { color: 'error', variant: 'contained' },
    action: () => console.log('[BAN_USER] Action triggered'),
  },
};
